import {TransactionEventTypeEnum} from "./TransactionEvent";

export enum TransactionEventCategory {
	All = "All",
	Received = "Received",
	Reconcile = "Reconcile",
	Notes = "Notes"
}

/**
 * Transaction event type object model.
 */
export default class TransactionEventTypeObject {
	constructor(public readonly id: string) {}

	/**
	 * Convert string to TransactionEventTypeObject.
	 * @param {string} string
	 * @return {TransactionEventTypeObject}
	 */
	public static fromString(string: string): TransactionEventTypeObject {
		return new TransactionEventTypeObject(string)
	}

	/**
	 * Get TransactionEventTypeObjects for given category.
	 * @param {string} filter Category key.
	 * @return {TransactionEventTypeObject[]} List of TransactionEventTypeObjects for given category.
	 */
	public static getTypesForCategory(filter: string): TransactionEventTypeObject[] {
		if (filter === TransactionEventCategory.All) {
			return TransactionEventTypeObject.getAllTypes();
		}
		if (filter === TransactionEventCategory.Received) {
			return TransactionEventTypeObject.getReceivedType();
		}
		if (filter === TransactionEventCategory.Reconcile) {
			return TransactionEventTypeObject.getReconcileType();
		}
		if (filter === TransactionEventCategory.Notes) {
			return TransactionEventTypeObject.getNoteTypes();
		}
		return null;
	}

	public static getAllTypes(): TransactionEventTypeObject[] {
		const result: TransactionEventTypeObject[] = [];
		for (let key in TransactionEventTypeEnum) {
			result.push(TransactionEventTypeObject.fromString(TransactionEventTypeEnum[key]));
		}
		return result;
	}

	public static getReceivedType(): TransactionEventTypeObject[] {
		return [
			TransactionEventTypeObject.fromString(TransactionEventTypeEnum.PaymentReceived)
		];
	}

	public static getReconcileType(): TransactionEventTypeObject[] {
		return [
			TransactionEventTypeObject.fromString(TransactionEventTypeEnum.PaymentReconciled),
			TransactionEventTypeObject.fromString(TransactionEventTypeEnum.UndoReconciliation)
		];
	}

	public static getNoteTypes(): TransactionEventTypeObject[] {
		return [
			TransactionEventTypeObject.fromString(TransactionEventTypeEnum.Note)
		];
	}
}
